export const formatCustomerLabel = (c) => {
    if (!c) return "";

    if (c.custCode && c.organizationName)
        return `${c.custCode} - ${c.organizationName}`;

    return c.custCode || c.organizationName || "";
};

export const formatBranchLabel = (b) => {
    if (!b) return "";

    if (b.branchCode && b.branchName)
        return `${b.branchCode} - ${b.branchName}`;

    return b.branchCode || b.branchName || "";
};

export const formatEmployeeLabel = (e) => {
    if (!e) return "";

    if (e.empCode && e.employeeName)
        return `${e.empCode} - ${e.employeeName}`;

    return e.empCode || e.employeeName || "";
};